<template>
  <section id="problemDeviceList" class="content">
    <!--no matching result-->
    <div
      class="accessory-list-default"
      v-show="isShowEmptyList"
    >
      <img
        src="../../../static/img/icon_no_matching_result.svg"
        class="center-block accessory-list-no-matching-img"
      >
      <div class="text-center col-sm-6 col-sm-offset-3">
        <h4 class="page-404-tips">No problem devices found.</h4>
      </div>
    </div>
    <!--no matching result-->
    <div
      class="row box problem-device-header"
      v-show="!isShowEmptyList"
    >
      <button
        class="btn btn-primary"
        v-on:click="downloadCSV"
      >Download CSV File</button>
    </div>

    <!--device list-->
    <div
      v-bind:class="['box', {'box-info': item.online}, {'box-warning': !item.online}]"
      v-for="item in list"
    >
      <div class="box-header with-border">
        <h3
          class="box-title device-list-name"
        >{{item.deviceid}}</h3>
        <span class="agent-list-id device-list-id">
          (
          <span>{{item.onlineText}}</span> )
        </span>
      </div>

      <div class="box-body">
        <table class="device-list-table">
          <tr class="device-list-row">
            <td class="col-xs-4">
              <span
                class="device-list-table-content"
              >AT+CSQ:&nbsp;</span>
              <span>{{item.csq}}</span>
            </td>
            <td class="col-xs-4 device-list-middle">
              <span
                class="device-list-table-content"
              >AT+CREG:&nbsp;</span>
              <span>{{item.creg}}</span>
            </td>
            <td class="col-xs-4 device-list-right">
              <span
                class="device-list-table-content"
              >AT+CGSN:&nbsp;</span>
              <span>{{item.cgsn}}</span>
            </td>
          </tr>
          <tr class="device-list-row">
            <td class="col-xs-4">
              <span
                class="device-list-table-content"
              >AT+CIMI:&nbsp;</span>
              <span>{{item.cimi}}</span>
            </td>
            <td class="col-xs-4 device-list-middle">
              <span
                class="device-list-table-content"
              >AT+CPIN:&nbsp;</span>
              <span>{{item.cpin}}</span>
            </td>
            <td class="col-xs-4 device-list-right">
              <span
                class="device-list-table-content"
              >AT+COPS:&nbsp;</span>
              <span>{{item.cops}}</span>
            </td>
          </tr>
        </table>
      </div>
      <!-- /.box-body -->
    </div>
    <!-- /.box -->
    <!--/ device list-->
  </section>
  <!-- /.content -->
</template>
<script>
import api from "../../api";
import utils from "../../utils";
// import global from "../Global.vue";

const formatList = arr =>
  arr.map(item => {
    const deviceid = Object.keys(item)[0];
    const itemData = item[deviceid];
    const online = !!itemData.online;
    const onlineText = online ? "online" : "offline";
    return { ...itemData, deviceid, online, onlineText };
  });

const limit = 20;
// const limit = 2

export default {
  name: "ProblemDevicesList",
  data() {
    return {
      list: [],
      isLoadMore: false
    };
  },
  computed: {
    isShowEmptyList() {
      return this.list.length < 1;
    }
  },
  filters: {
    formatTime(time) {
      return utils.formatDate(new Date(time / 1000000), "yyyy-MM-dd hh:mm:ss");
    },
    capitalize(cmdname) {
      return utils.capitalize(cmdname);
    }
  },
  methods: {
    async fetch() {
      const list = await api.post({
        path: "/getsimdatalist?_type=json",
        data: {
          appid: this.$route.query.appid,
          skip: this.list.length,
          limit,
          sim: 2
        },
        withLoading: true
      });
      this.list.push(...formatList(list));

      // var params = new URLSearchParams();
      // var jsons = {
      //   appid: this.$route.query.appid,
      //   skip: this.list.length,
      //   limit,
      //   sim: 2
      // };
      // params.append(
      //   "json",
      //   utils.getRC4Hex(JSON.stringify(jsons), global.APP_SECRET)
      // );
      // if (window.localStorage) {
      //   params.append("token", this.$router.app.$store.state.user.token);
      // }

      // const response = await api.request(
      //   "post",
      //   "/getsimdatalist?_type=json",
      //   params
      // );
      // if (response) {
      //   var { data } = response;
      //   var { Result } = data;
      //   if (Result) {
      //     var list = JSON.parse(
      //       utils.getDecodeRC4Hex(Result, global.APP_SECRET)
      //     );
      //     this.list.push(...formatList(list));
      //   }
      // }
    },
    handleScroll(e) {
      var jqueryWindow = window.jQuery(window);
      var listNodeHeight = window.jQuery("#problemDeviceList").height();
      var windowScrollTop = jqueryWindow.scrollTop();
      var windowHeight = jqueryWindow.height();
      if (
        this.currentDeviceListHeight < listNodeHeight &&
        windowScrollTop + windowHeight >= listNodeHeight
      ) {
        this.currentDeviceListHeight = windowScrollTop + windowHeight;
        this.fetch();
      }
    },
    downloadCSV() {
      const titles = [
        "AT+CSQ",
        "AT+CREG",
        "AT+CGSN",
        "AT+CIMI",
        "AT+CPIN",
        "AT+COPS"
      ].sort();
      titles.unshift("ID");
      const join = dataset => dataset.join(",");
      const csv = this.list
        .reduce(
          (arr, item) => {
            const { deviceid, ...rest } = item;
            arr.push(
              join([
                deviceid,
                ...Object.keys(rest)
                  .sort()
                  .map(key => rest[key])
              ])
            );
            return arr;
          },
          [join(titles)]
        )
        .join("\n");
      const fragment = document.createElement("a");
      fragment.href = "data:text/csvcharset=utf-8," + encodeURI(csv);
      fragment.target = "_blank";
      fragment.download = "problem_devices.csv";
      fragment.click();
    }
  },
  async mounted() {
    this.$store.commit("TOGGLE_FULLSCREEN_LOADING");
    await this.fetch();
    this.$store.commit("TOGGLE_FULLSCREEN_LOADING");
    this.currentDeviceListHeight = 0;
    window.addEventListener("scroll", this.handleScroll, false);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll, false);
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// ProblemDeviceList.vue?38ba0e61